var map = {
	"./BearCallSpread.svg": 54984,
	"./BearPutSpread.svg": 85209,
	"./BullCallSpread.svg": 22425,
	"./BullPutSpread.svg": 12026,
	"./Buy.svg": 85717,
	"./ContractIcon.svg": 3338,
	"./Donut.svg": 72393,
	"./ExpansionIcon.svg": 18145,
	"./FeedbackIcon.svg": 60297,
	"./Frame.svg": 30798,
	"./IronButterfly.svg": 27962,
	"./IronCondor.svg": 77390,
	"./LongStraddle.svg": 64646,
	"./LongStrangle.svg": 82567,
	"./Neutral.svg": 43460,
	"./NoStrategy.svg": 27709,
	"./RatioCallSpread.svg": 63493,
	"./RatioPutSpread.svg": 64062,
	"./Sell.svg": 95811,
	"./Share.svg": 62596,
	"./ShortStraddle.svg": 5460,
	"./ShortStrangle.svg": 78941,
	"./StrategyBuilder.svg": 94309,
	"./StrategyStore.svg": 42843,
	"./add-money.svg": 3471,
	"./additem.svg": 95861,
	"./arrow-square-down.svg": 81051,
	"./arrow-square-up.svg": 42228,
	"./arrow.svg": 57190,
	"./dropdownArrow.svg": 11311,
	"./edit-2.svg": 81610,
	"./fund-circle.svg": 3475,
	"./hamburger.svg": 61180,
	"./info-circle.svg": 13328,
	"./info-circle2.svg": 79330,
	"./logout.svg": 34277,
	"./menu.svg": 72434,
	"./notification-status.svg": 18493,
	"./refresh.svg": 32304,
	"./search-icon.svg": 35691,
	"./search-normal.svg": 16145,
	"./send-2.svg": 59704,
	"./setting-3.svg": 46005,
	"./shopping-cart.svg": 5302,
	"./symbols_save.svg": 75198,
	"./tick-circle-gray.svg": 12335,
	"./tick-circle-green.svg": 55123,
	"./tick-circle.svg": 78181,
	"./toolsFooter.svg": 42657,
	"./trash.svg": 36891,
	"./userSetting.svg": 33030
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;